export default __webpack_public_path__ + "static/media/TD.1e912db2.svg";